import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPolicy,
  head: () =>
    pageHead({
      title: "Privacy Policy | jaik",
      description: "How jaik collects, uses, and protects your personal information. GDPR, CCPA, and Washington Privacy Act compliant.",
      path: "/privacy",
    }),
});
